(function () {
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $cd5a47cf8ef6d766$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $09cbfe85151ea6c6$export$71511d61b312f219)(arr) || (0, $8ca2848f896a6803$export$71511d61b312f219)(arr, i) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr, i) || (0, $a0bc1859061deae1$export$71511d61b312f219)();
}


"use strict";
var $3d28d7f1aac198f5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Game() {
        var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.initialState = initialState ? Game._deepCopyBoard(initialState) : Game._emptyBoard();
        this.board = Game._deepCopyBoard(this.initialState);
        this.score = 0;
        this.status = "not_started";
        this._hasStarted = false;
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "getState",
            value: function getState() {
                return Game._deepCopyBoard(this.board);
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "start",
            value: function start() {
                if (this._hasStarted) return;
                this._hasStarted = true;
                this.status = "playing";
                if (Game._isBoardEmpty(this.board)) {
                    this._spawnRandom();
                    this._spawnRandom();
                }
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.board = Game._deepCopyBoard(this.initialState);
                this.score = 0;
                this.status = "not_started";
                this._hasStarted = false;
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                return this._move(function(row) {
                    return Game._moveArrayLeft(row);
                });
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                return this._move(function(row) {
                    return Game._moveArrayRight(row);
                });
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                this.board = Game._transpose(this.board);
                var moved = this._move(function(row) {
                    return Game._moveArrayLeft(row);
                });
                this.board = Game._transpose(this.board);
                return moved;
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                this.board = Game._transpose(this.board);
                var moved = this._move(function(row) {
                    return Game._moveArrayRight(row);
                });
                this.board = Game._transpose(this.board);
                return moved;
            }
        },
        {
            key: "_move",
            value: function _move(transformRowFn) {
                if (this.status === "over" || this.status === "won") return false;
                if (!this._hasStarted) this.start();
                var beforeState = JSON.stringify(this.board);
                var mergedSumThisMove = 0;
                var newBoard = this.board.map(function(row) {
                    var _transformRowFn = transformRowFn(row), newRow = _transformRowFn.newRow, mergedSum = _transformRowFn.mergedSum;
                    mergedSumThisMove += mergedSum;
                    return newRow;
                });
                if (JSON.stringify(newBoard) === beforeState) return false;
                this.board = newBoard;
                this.score += mergedSumThisMove;
                if (Game._boardHasValue(this.board, Game.WIN_TILE)) this.status = "won";
                this._spawnRandom();
                if (!this._hasAnyMoves()) this.status = "over";
                else if (this.status !== "won") this.status = "playing";
                return true;
            }
        },
        {
            key: "_spawnRandom",
            value: function _spawnRandom() {
                var emptyCells = [];
                for(var rowIdx = 0; rowIdx < Game.SIZE; rowIdx++){
                    for(var colIdx = 0; colIdx < Game.SIZE; colIdx++)if (this.board[rowIdx][colIdx] === 0) emptyCells.push([
                        rowIdx,
                        colIdx
                    ]);
                }
                if (emptyCells.length === 0) return false;
                var _emptyCells_Math_floor = (0, $efec029548ccee7f$export$71511d61b312f219)(emptyCells[Math.floor(Math.random() * emptyCells.length)], 2), r = _emptyCells_Math_floor[0], c = _emptyCells_Math_floor[1];
                var value = Math.random() < 0.1 ? 4 : 2;
                this.board[r][c] = value;
                return true;
            }
        },
        {
            key: "_hasAnyMoves",
            value: function _hasAnyMoves() {
                if (Game._isBoardEmptyCellPresent(this.board)) return true;
                for(var rowIdx = 0; rowIdx < Game.SIZE; rowIdx++)for(var colIdx = 0; colIdx < Game.SIZE - 1; colIdx++){
                    if (this.board[rowIdx][colIdx] === this.board[rowIdx][colIdx + 1]) return true;
                }
                for(var colIdx1 = 0; colIdx1 < Game.SIZE; colIdx1++)for(var rowIdx1 = 0; rowIdx1 < Game.SIZE - 1; rowIdx1++){
                    if (this.board[rowIdx1][colIdx1] === this.board[rowIdx1 + 1][colIdx1]) return true;
                }
                return false;
            }
        }
    ], [
        {
            key: "_emptyBoard",
            value: function _emptyBoard() {
                return Array.from({
                    length: Game.SIZE
                }, function() {
                    return Array(Game.SIZE).fill(0);
                });
            }
        },
        {
            key: "_deepCopyBoard",
            value: function _deepCopyBoard(board) {
                return board.map(function(row) {
                    return row.slice();
                });
            }
        },
        {
            key: "_isBoardEmpty",
            value: function _isBoardEmpty(board) {
                for(var i = 0; i < Game.SIZE; i++)for(var j = 0; j < Game.SIZE; j++){
                    if (board[i][j] !== 0) return false;
                }
                return true;
            }
        },
        {
            key: "_isBoardEmptyCellPresent",
            value: function _isBoardEmptyCellPresent(board) {
                for(var i = 0; i < Game.SIZE; i++)for(var j = 0; j < Game.SIZE; j++){
                    if (board[i][j] === 0) return true;
                }
                return false;
            }
        },
        {
            key: "_boardHasValue",
            value: function _boardHasValue(board, value) {
                for(var i = 0; i < Game.SIZE; i++)for(var j = 0; j < Game.SIZE; j++){
                    if (board[i][j] === value) return true;
                }
                return false;
            }
        },
        {
            key: "_transpose",
            value: function _transpose(board) {
                var newBoard = Game._emptyBoard();
                for(var i = 0; i < Game.SIZE; i++)for(var j = 0; j < Game.SIZE; j++)newBoard[j][i] = board[i][j];
                return newBoard;
            }
        },
        {
            key: "_moveArrayLeft",
            value: function _moveArrayLeft(row) {
                var size = row.length;
                var tiles = row.filter(function(v) {
                    return v !== 0;
                });
                var mergedFlags = Array(tiles.length).fill(false);
                var mergedSum = 0;
                for(var i = 0; i < tiles.length - 1; i++)if (!mergedFlags[i] && tiles[i] === tiles[i + 1]) {
                    tiles[i] *= 2;
                    mergedSum += tiles[i];
                    tiles.splice(i + 1, 1);
                    mergedFlags[i] = true;
                    mergedFlags.splice(i + 1, 1);
                }
                var newRow = tiles.concat(Array(size - tiles.length).fill(0));
                return {
                    newRow: newRow,
                    mergedSum: mergedSum
                };
            }
        },
        {
            key: "_moveArrayRight",
            value: function _moveArrayRight(row) {
                var reversed = row.slice().reverse();
                var _Game__moveArrayLeft = Game._moveArrayLeft(reversed), newRow = _Game__moveArrayLeft.newRow, mergedSum = _Game__moveArrayLeft.mergedSum;
                return {
                    newRow: newRow.reverse(),
                    mergedSum: mergedSum
                };
            }
        }
    ]);
    return Game;
}();
(0, $cd5a47cf8ef6d766$export$71511d61b312f219)($3d28d7f1aac198f5$export$2e2bcd8739ae039, "SIZE", 4);
(0, $cd5a47cf8ef6d766$export$71511d61b312f219)($3d28d7f1aac198f5$export$2e2bcd8739ae039, "WIN_TILE", 2048);


"use strict";
var $197cd56b15c33885$var$game = new (0, $3d28d7f1aac198f5$export$2e2bcd8739ae039)();
var $197cd56b15c33885$var$cells = Array.from(document.querySelectorAll(".field-cell"));
var $197cd56b15c33885$var$scoreEl = document.querySelector(".game-score");
var $197cd56b15c33885$var$startBtn = document.querySelector(".button");
var $197cd56b15c33885$var$messageWin = document.querySelector(".message-win");
var $197cd56b15c33885$var$messageLose = document.querySelector(".message-lose");
var $197cd56b15c33885$var$messageStart = document.querySelector(".message-start");
function $197cd56b15c33885$var$render() {
    var state = $197cd56b15c33885$var$game.getState();
    var idx = 0;
    for(var r = 0; r < 4; r++)for(var c = 0; c < 4; c++){
        var val = state[r][c];
        var el = $197cd56b15c33885$var$cells[idx];
        el.className = "field-cell";
        if (val !== 0) {
            el.textContent = val;
            el.classList.add("field-cell--".concat(val));
        } else el.textContent = "";
        idx++;
    }
    $197cd56b15c33885$var$scoreEl.textContent = $197cd56b15c33885$var$game.getScore();
    var gameStatus = $197cd56b15c33885$var$game.getStatus();
    $197cd56b15c33885$var$messageWin.classList.add("hidden");
    $197cd56b15c33885$var$messageLose.classList.add("hidden");
    $197cd56b15c33885$var$messageStart.classList.add("hidden");
    $197cd56b15c33885$var$startBtn.className = "button";
    if (gameStatus === "not_started") {
        $197cd56b15c33885$var$startBtn.textContent = "Start";
        $197cd56b15c33885$var$startBtn.classList.add("start");
        $197cd56b15c33885$var$messageStart.classList.remove("hidden");
    } else if (gameStatus === "playing") {
        $197cd56b15c33885$var$startBtn.textContent = "Restart";
        $197cd56b15c33885$var$startBtn.classList.add("restart");
    } else if (gameStatus === "won") {
        $197cd56b15c33885$var$startBtn.textContent = "Restart";
        $197cd56b15c33885$var$startBtn.classList.add("restart");
        $197cd56b15c33885$var$messageWin.classList.remove("hidden");
    } else if (gameStatus === "over") {
        $197cd56b15c33885$var$startBtn.textContent = "Restart";
        $197cd56b15c33885$var$startBtn.classList.add("restart");
        $197cd56b15c33885$var$messageLose.classList.remove("hidden");
    }
}
document.addEventListener("keydown", function(e) {
    var moved = false;
    switch(e.key){
        case "ArrowLeft":
            moved = $197cd56b15c33885$var$game.moveLeft();
            break;
        case "ArrowRight":
            moved = $197cd56b15c33885$var$game.moveRight();
            break;
        case "ArrowUp":
            moved = $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowDown":
            moved = $197cd56b15c33885$var$game.moveDown();
            break;
    }
    if (moved) $197cd56b15c33885$var$render();
});
$197cd56b15c33885$var$startBtn.addEventListener("click", function() {
    if ($197cd56b15c33885$var$game.getStatus() === "not_started") $197cd56b15c33885$var$game.start();
    else $197cd56b15c33885$var$game.restart();
    $197cd56b15c33885$var$render();
});
$197cd56b15c33885$var$render();

})();
//# sourceMappingURL=index.cf0e31ab.js.map
